import React from 'react';
import { useController } from 'react-hook-form';

import { ManufacturerInput, ManufacturerInputProps } from 'components/inputs/ManufacturerInput';
import { CompanyProfileService } from 'services/CompanyProfileService';

type ManufacturerFieldProps = Partial<ManufacturerInputProps> & {
    name: string;
    disabled?: boolean;
};

const ManufacturerField = ({ name, ...props }: ManufacturerFieldProps) => {
    const {
        field,
        fieldState: { error },
    } = useController({ name });

    return (
        <ManufacturerInput
            {...props}
            name={name}
            value={field.value}
            error={error?.message}
            onOptionSubmit={async (value, query, mutate) => {
                if (value === '$new') {
                    const { doc } = await CompanyProfileService.create({
                        name: query,
                    });

                    field.onChange(doc.id);
                    await mutate();
                } else {
                    field.onChange(value);
                }
            }}
            onBlur={() => field.onBlur()}
        />
    );
};

export { ManufacturerField };
